import React from 'react';
import './HowWorks.css'

const HowWorks = () => {
    return (
        <div>
            <h1>How it works page comming soon</h1>
        </div>
    );
};

export default HowWorks;